import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { BasicTable } from "../UI/Table/BasicTable.tsx";
import { formatDate } from "../UI/Utils/formatDate.ts";
import { BulkClassRoomCreationIntentFragment } from "../gql/graphql.ts";

const HIDDEN_ON_MOBILE = { className: "hidden md:table-cell" };

const columnHelper = createColumnHelper<BulkClassRoomCreationIntentFragment>();

function fullNameOf(
  person: { givenName: string; familyName: string } | null | undefined,
): string {
  return person ? `${person.givenName} ${person.familyName}` : "—";
}

const columns = [
  columnHelper.accessor("createdAt", {
    header: "Data creazione",
    meta: HIDDEN_ON_MOBILE,
    cell: (info) => (
      <span className={"whitespace-nowrap"}>
        {formatDate(info.getValue(), { locale: "it" })}
      </span>
    ),
  }),
  columnHelper.display({
    id: "teacher",
    header: "Teacher",
    meta: HIDDEN_ON_MOBILE,
    cell: ({ row }) => fullNameOf(row.original.teacher),
  }),
  columnHelper.display({
    id: "student",
    header: "Studente",
    cell: ({ row }) => fullNameOf(row.original.user),
  }),
  columnHelper.accessor("startDate", {
    header: "Data inizio",
    cell: (info) => {
      const startDate = info.getValue();
      return (
        <span className={"whitespace-nowrap"}>
          {startDate ? formatDate(startDate, { locale: "it" }) : "—"}
        </span>
      );
    },
  }),
  columnHelper.accessor("numberOfWeeks", {
    header: "Settimane",
    meta: HIDDEN_ON_MOBILE,
    cell: (info) => info.getValue() ?? "—",
  }),
  columnHelper.accessor("maxClassRoomNumber", {
    header: "Max classi",
    meta: HIDDEN_ON_MOBILE,
    cell: (info) => info.getValue() ?? "—",
  }),
];

export function UnredeemedPlansTable({
  intents,
  onOpenIntent,
}: {
  intents: BulkClassRoomCreationIntentFragment[];
  onOpenIntent: (intentId: string) => void;
}) {
  const table = useReactTable({
    columns,
    data: intents,
    getCoreRowModel: getCoreRowModel(),
  });
  return (
    <BasicTable
      table={table}
      compact
      scrollableMinWidthClassName={"min-w-full"}
      onRowClick={(intent) => onOpenIntent(intent.id)}
    />
  );
}
